var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "content" }, [
        _c("p", { domProps: { textContent: _vm._s(_vm.content) } }),
        _c("p", [
          _c(
            "button",
            {
              staticClass: "button is-primary",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.downloadableContent.apply(null, arguments)
                },
              },
            },
            [_vm._v(" Download " + _vm._s(_vm.data.title) + " ")]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }